import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  OutlinedInput,
  Tooltip,
  Typography,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import InputAdornment from "@mui/material/InputAdornment";
import Buttons from "../../../components/Controls/Buttons/Button";
import React, { useEffect, useState } from "react";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";
import FormGroup from "@mui/material/FormGroup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import "./userForm.scss";
import Checkbox from "@mui/material/Checkbox";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { messages } from "../../../constants/commonMessages";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import { Info } from "@mui/icons-material";
import FiberManualRecordTwoToneIcon from "@mui/icons-material/FiberManualRecordTwoTone";
import { adminRoutes } from "../../../routes/routeConstants";

const Index = (props) => {
  const location = useLocation();

  let userInfo = location?.state?.userdata;
  const [firstname, setFirstName] = React.useState(userInfo?.first_name || "");
  const [lastname, setLastName] = React.useState(userInfo?.last_name || "");
  const [username, setUsername] = React.useState(userInfo?.username || "");
  const [email, setEmail] = React.useState(userInfo?.email || "");
  const [password, setPassword] = React.useState("");

  // Extract main role and sub-role from groups array
  const userGroups = userInfo?.groups || [];
  const mainRole = userGroups[0] || "";
  const detectedSubRole = userGroups.includes("viewer")
    ? "viewer"
    : userGroups.includes("reviewer")
      ? "reviewer"
      : "";

  const [group, setGroup] = React.useState(mainRole);
  const [subRole, setSubRole] = React.useState(detectedSubRole); // Sub-role for Investigator
  const [confirmpass, setConfirmPass] = React.useState("");
  const [message, setMsg] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("1234456");
  const [isPass, setIsPass] = React.useState(userInfo?.id ? false : true);
  const [passwordType, setPasswordType] = useState(false);
  const [confirmPasswordType, setConfirmPasswordType] = useState(false);
  const [err, setErr] = useState(false);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const Dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = location?.state?.userdata?.id;
  const [severity, setSeverity] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    Dispatch(acts.getManageGroupsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //Success and error notification
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true && apiStatus?.next === false) {
        setMsg(apiStatus?.message);
        setSeverity("error");
        setErr(true);
      }
    }
  }, [apiStatus]);

  const groupData = useSelector((state) => state?.admin?.group);
  const data = useSelector((state) => state?.admin?.userState);

  const requirements = [
    { key: "length", text: "8-20 characters" },
    { key: "lowercase", text: "At least one lowercase letter" },
    { key: "uppercase", text: "At least one uppercase letter" },
    { key: "number", text: "At least one number" },
    { key: "specialChar", text: "At least one special character (@#$%^&+=)" },
    { key: "noSpace", text: "No spaces allowed" },
  ];

  useEffect(() => {
    //new user creation or alteration
    if (data?.message === "user added") {
      setIsOpen(true);
      setSeverity("success");
      setSuccessMessage(messages.USER_ADDED);
      setTimeout(() => {
        // navigate("/manage-user");
        navigate(`/${adminRoutes.manageUser}`);
      }, 3000);
    } else if (data?.message === "user edited") {
      setIsOpen(true);
      setSuccessMessage(messages.USER_EDIT);
      setSeverity("success");
      setTimeout(() => {
        // navigate("/manage-user");
        navigate(`/${adminRoutes.manageUser}`);
      }, 3000);
    } else if (data?.message === "error") {
      setIsOpen(true);
      setSuccessMessage(messages.FAIL_USER);
      setSeverity("error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleSubmit = () => {
    if (password !== confirmpass) {
      return setMsg(messages.PASSWORD_NOT_MATCH);
    } else {
      setMsg("");
    }

    // Validate sub-role for Investigator
    if (group === "investigator" && !subRole) {
      return setMsg(
        "Please select a sub-role (Viewer or Reviewer) for Investigator",
      );
    }

    // Build groups array - include both main role and sub-role for Investigator
    let groupsArray = [group];
    if (group === "investigator" && subRole) {
      // Add sub-role as a second group (viewer or reviewer)
      groupsArray.push(subRole);
    }

    let user = {
      first_name: firstname,
      last_name: lastname,
      username: username,
      email: email,
      password: password,
      groups: groupsArray, // Send both groups in the array
    };

    if (userId) {
      //edit user api call
      Dispatch(acts.editUser(user, userId));
    } else {
      Dispatch(acts.addNewUser(user));
    }
  };

  const [state, setState] = React.useState({});

  const handleChange = (event) => {
    const selectedGroup = event.target.value;
    setGroup(selectedGroup);
    // Reset sub-role if not Investigator
    if (selectedGroup !== "investigator") {
      setSubRole("");
    }
    setState({
      ...state,
      [selectedGroup]: event.target.checked,
    });
  };

  const handleSubRoleChange = (event) => {
    setSubRole(event.target.value);
  };

  const togglePassword = () => {
    setPasswordType(!passwordType);
  };
  const toggleConfirmPassword = () => {
    setConfirmPasswordType(!confirmPasswordType);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Header page="new-project" />
      {isOpen ? (
        <CustomizedSnackbars
          className="popup"
          handleClose={() => {
            setIsOpen(false);
          }}
          severity={severity}
          state={isOpen}
          text={successMessage}
        />
      ) : (
        <></>
      )}
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <Box className="header-container">
              <Link
                // to="/manage-user"
                to={`/${adminRoutes.manageUser}`}
              >
                <IconButton className="backarrow-icon-style">
                  <ArrowBackIcon />
                </IconButton>
              </Link>
              <p className="arrow-text-style">
                {userId ? messages.EDIT_USER : messages.ADD_USER}
              </p>
            </Box>
            <form
              onSubmit={(event) => {
                event.preventDefault();
                handleSubmit();
              }}
            >
              <Grid container className="data-grid-container" id="user-form">
                <Grid item md={4} className="inner-grid-container1">
                  <Typography>{messages.F_NAME}</Typography>
                  <OutlinedInput
                    type="text"
                    placeholder={messages.ENTER_F_NAME}
                    value={firstname}
                    onChange={(event) => setFirstName(event.target.value)}
                    required
                    onInvalid={(e) => (e.target.style.border = "1px solid red")}
                  />
                  <Typography>{messages.L_NAME}</Typography>
                  <OutlinedInput
                    className="firstname"
                    type="text"
                    value={lastname}
                    onChange={(event) => setLastName(event.target.value)}
                    placeholder={messages.ENTER_L_NAME}
                    required
                    onInvalid={(e) => (e.target.style.border = "1px solid red")}
                  />
                  <Typography>{messages.EMAIL}</Typography>
                  <OutlinedInput
                    className="firstname"
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder={messages.ENTER_EMAIL}
                    required
                    onInvalid={(e) => (e.target.style.border = "1px solid red")}
                  />
                </Grid>
                <Grid item md={4} className="inner-grid-container2">
                  <Typography>Username</Typography>
                  <OutlinedInput
                    className="firstname"
                    type="text"
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                    placeholder={messages.ENTER_USER_NAME}
                    fullWidth
                    required
                    onInvalid={(e) => (e.target.style.border = "1px solid red")}
                  />
                  {userId && (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Update Password"
                        onChange={(event) => setIsPass(event.target.checked)}
                      />
                    </FormGroup>
                  )}

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography>Password</Typography>

                    <Tooltip
                      title={
                        <List sx={{ p: "0px 0px 10px 0px" }} dense={true}>
                          {requirements?.map((req) => (
                            <ListItem
                              key={req.key}
                              sx={{
                                padding: "0px 5px 0px 5px",
                                minHeight: "25px",
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: "24px",
                                  mr: 0.5,
                                  ml: 0,
                                  p: 0,
                                  "& svg": {
                                    height: "18px !important",
                                  },
                                }}
                              >
                                <FiberManualRecordTwoToneIcon
                                  sx={{ color: "white" }}
                                />
                              </ListItemIcon>

                              <ListItemText
                                // primaryTypographyProps={{
                                //   color: "text.primary",
                                //   fontWeight: "small",
                                //   variant: "body2",
                                // }}
                                primary={req.text}
                                sx={{
                                  m: 0,
                                  typography: "body3",
                                  lineHeight: 1,
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      }
                      arrow
                    >
                      <IconButton aria-label="delete" size="small">
                        <Info color="primary" size="small" />
                      </IconButton>
                      {/* <Info color="action" sx={{ ml: 1, cursor: "pointer" }} /> */}
                    </Tooltip>
                  </div>

                  <OutlinedInput
                    type={passwordType ? "text" : "password"}
                    inputProps={{
                      pattern:
                        "^(?=.*[0-9])" +
                        "(?=.*[a-z])(?=.*[A-Z])" +
                        "(?=.*[@#$%^&+=])" +
                        "(?=\\S+$).{8,20}$",
                    }}
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    placeholder="Password"
                    required
                    disabled={!isPass}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={togglePassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {passwordType ? (
                            <Visibility />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    onInvalid={(e) => (e.target.style.border = "1px solid red")}
                  />
                  <Typography>Confirm password</Typography>
                  <OutlinedInput
                    className="outline-input-style"
                    type={confirmPasswordType ? "text" : "password"}
                    value={confirmpass}
                    onChange={(event) => setConfirmPass(event.target.value)}
                    placeholder="Confirm password"
                    required
                    disabled={!isPass}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={toggleConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {confirmPasswordType ? (
                            <Visibility />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    onInvalid={(e) => (e.target.style.border = "1px solid red")}
                  />
                  <Typography className="text-message-style">
                    {message}
                  </Typography>
                </Grid>
                <Grid md={4} className="inner-grid-container3">
                  <Box>
                    <FormControl
                      className="form-style"
                      component="fieldset"
                      variant="standard"
                    >
                      <FormLabel component="legend">Group</FormLabel>
                      <FormGroup>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="group"
                          name="radio-buttons-group"
                          className="radio-group-style"
                        >
                          {groupData &&
                            groupData
                              ?.filter(
                                (items) =>
                                  items.name !== "viewer" &&
                                  items.name !== "reviewer" &&
                                  items.name !== "srm_processor" &&
                                  items.name !== "srm_admin",
                              ) // Exclude viewer and reviewer from main groups
                              ?.map((items) => {
                                return (
                                  <FormControlLabel
                                    value={items.name}
                                    control={<Radio required />}
                                    checked={items.name === group}
                                    label={
                                      items.name.charAt(0).toUpperCase() +
                                      items.name.slice(1)
                                    }
                                    onChange={handleChange}
                                  />
                                );
                              })}
                        </RadioGroup>
                      </FormGroup>
                    </FormControl>
                  </Box>

                  {/* Sub-role selector for Investigator - separate section */}
                  {group === "investigator" && (
                    <Box className="sub-role-container">
                      <FormControl
                        className="form-style"
                        component="fieldset"
                        variant="standard"
                      >
                        <FormLabel
                          component="legend"
                          sx={{ color: "primary.main", fontWeight: 500 }}
                        >
                          Sub-role
                        </FormLabel>

                        <FormGroup>
                          <RadioGroup
                            aria-labelledby="sub-role-radio-buttons-group-label"
                            name="sub-role-radio-buttons-group"
                            value={subRole}
                            onChange={handleSubRoleChange}
                            row
                            sx={{ mt: 1 }}
                          >
                            {groupData &&
                              groupData
                                ?.filter(
                                  (item) =>
                                    item.name === "srm_processor" ||
                                    item.name === "srm_admin",
                                )
                                ?.map((item) => (
                                  <FormControlLabel
                                    key={item.id}
                                    value={item.name}
                                    control={<Radio required />}
                                    label={
                                      item.name === "srm_processor"
                                        ? "SRM Processor"
                                        : item.name === "srm_admin"
                                          ? "SRM Admin"
                                          : item.name
                                    }
                                    sx={{ mr: 4 }}
                                  />
                                ))}
                          </RadioGroup>
                        </FormGroup>
                      </FormControl>
                    </Box>
                  )}
                </Grid>
              </Grid>

              <Box className="bottom-div">
                <Buttons
                  variant="contained"
                  size="large"
                  text="save"
                  type="submit"
                />
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
      {err && (
        <CustomizedSnackbars
          severity={severity}
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </>
  );
};

export default Index;
